exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proof-next-version-dropzone[data-v-01d47a22]{min-height:126px}#proof-next-version-add-files[data-v-01d47a22]{padding-top:45px}.dz-uploaded-file[data-v-01d47a22]{cursor:default}.dz-uploaded-file .dz-upload-info[data-v-01d47a22]{left:160px}.dz-uploaded-file .dz-progress[data-v-01d47a22]{width:calc(100% - 172px)}.clear-date[data-v-01d47a22]{position:absolute;top:2px;right:2px}", ""]);

// exports
